import * as React from 'react'
import { useClient } from '@based/sdk/react'

export function useUploadFile() {
  const client = useClient()
  const [status, setStatus] = React.useState<
    'initial' | 'uploading' | 'success' | 'error'
  >('initial')
  const [progress, setProgress] = React.useState(0)
  const [newSrc, setNewSrc] = React.useState('')

  function handleFileInputChange(
    successHandler: (
      uploadedFile: { id: string; src: string; name: string } | null,
    ) => void,
  ) {
    return async function (file?: File) {
      try {
        if (!file) {
          successHandler(null)
          return
        }
        setStatus('uploading')

        const { id, src, name } = await client.stream(
          'file-upload',
          {
            contents: file,
            fileName: file.name,
            mimeType: file.type,
            size: file.size,
          },
          (value) => {
            setProgress(value * 100)
          },
        )

        setNewSrc(src)
        setStatus('success')
        successHandler({ id, src, name })
      } catch (e) {
        setStatus('error')
      }
    }
  }

  return { status, progress, handleFileInputChange, newSrc }
}
